import React, { FC } from 'react'

const Sidebar: FC = (props) => {
  const { children } = props

  return (
    <>
      <div className="fixed right-0 top-0 bottom-0 lg:w-[380px] w-[300px] bg-[#F5F3FF]">
        {children}
      </div>

      <div className="lg:w-[380px] w-[300px]" />
    </>
  )
}

export default Sidebar
